import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {SoVanThuService} from '../../../service/info/service-sovanthu';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {SoVanThu} from '../../../models/info/sovanthu';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {DonViService} from '../../../service/danhmuc/service-donvi';
import {DonVi} from '../../../models/danhmuc/donvi';
import {observable} from 'rxjs';
import {SoVanThuDVService} from '../../../service/info/service-sovanthudv';
@Component({
  selector: 'app-views-info-sovanthu',
  templateUrl: './sovanthu.component.html'

})export class SoVanThuComponent implements OnInit {
  @ViewChild('largeModal') public largeModal: ModalDirective;
  public language = language;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  public isRefresh: boolean = false;
  public dataList: SoVanThu[];
  public submitValidate = false;
  public keyword: string = '';
  public showCheckBox: boolean = true;
  public dataTree: DonVi[];
  public dataDonVi: Object[] = [];
  public soVanThuId: number =0;
  @ViewChild('treeview') public tree: TreeViewComponent;
  public fieldTree: Object;
  constructor( public soVanThuService: SoVanThuService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public donViService: DonViService,
               public soVanThuDVService: SoVanThuDVService

  ) {

  }
  ngOnInit(): void {
    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      tenSoVanThu: new FormControl(),
      soVaoSo: new FormControl(),
      suDung: new FormControl('0'),
      stt: new FormControl(),
      kyHieuVanBan: new FormControl()
    });
    this.frmGroup = this.formBuilder.group({
      tenSoVanThu: ['' , Validators.compose([validateEmpty]) ],
      stt: ['', Validators.compose([validateEmpty, Validators.pattern('[0-9]*')])],
      soVaoSo: ['', Validators.required],
      id: ['', Validators.nullValidator],
      suDung: ['', Validators.nullValidator],
      kyHieuVanBan: ['', Validators.nullValidator]
    });
    this.search(this.keyword);

  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  public showDonVi(id: number): void {
    this.soVanThuId = id;
    this.donViService.getAll().subscribe(x => {
      this.dataTree = x;
      this.dataDonVi = [];
      for(let i=0; i< this.dataTree.length; i++)
      {
        this.dataDonVi.push(
          this.dataTree[i].maCapTren ==0 ?
            { id: this.dataTree[i].id,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: true
            }
            :
          { id: this.dataTree[i].id,
            pid: this.dataTree[i].maCapTren,
            name: this.dataTree[i].tenCQ,
            hasChild: this.dataTree[i].hasChild,
            expanded: false
          });
      }
     this.fieldTree= { dataSource: this.dataDonVi, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild' };

      this.largeModal.show();
    });

  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
    this.isEdit = true;
    this.soVanThuService.getById(id).pipe(first())
      .subscribe(x => this.frmGroup.patchValue(x));

  }
  search(keyword)
  {
    this.keyword = keyword;
    this.soVanThuService.findAllByPaging(keyword, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.soVanThuService.getCountByKeyword(keyword).subscribe(recordCount => this.totalItems = recordCount);
  }
  refresh()
  {
    this.isEdit = false;
    this.frmGroup.setValue({id: 0, suDung: 1, stt: '', tenSoVanThu: '', soVaoSo: '', kyHieuVanBan: ''});
  }
  createItem ()
  {
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.soVanThuService.add(this.frmGroup.value).subscribe({
      next: () => {
        this.toastr.success(language.add_success_record, language.message);
        this.search(this.keyword);

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  updateItem()
  {
    this.frmGroup.controls['suDung'].setValue(this.isSuDung == false ? 0: 1);
    this.soVanThuService.update(this.frmGroup.value).subscribe({
      next: () => {
        this.toastr.success(language.update_success_record, language.message);
        this.search(this.keyword);

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  deleteItem(id: number)
  {
    this.soVanThuService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search(this.keyword);

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    if (this.isEdit)
      this.updateItem();
    else
      this.createItem();
  }
  changeHandler(event: any)
  {
    console.log(event.target.value);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search(this.keyword);

  }
  changeActive(event: any, id: number): void {

    this.soVanThuService.changeStatus(id, event.target.checked!).subscribe({
      next: () => {
        this.toastr.success(event.target.checked === false ? language.message_off : language.message_on, language.message);
        this.search(this.keyword);

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public saveDonVi()
  {
    let arrDV: string = this.tree.getAllCheckedNodes().join();
    this.soVanThuDVService.addMulti(this.soVanThuId,arrDV).subscribe({
      next: () => {
        this.toastr.success( language.message_add_sovanthu_donvi_success, language.message);
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });


  }
  public nodeChecked(args): void {


  }

}
